// 範圍樹節點的顯示名（頁首範圍、左樹、路徑共用；原本在 features/shell/Shell，搬來 lib 讓 lib/scope 的路徑函式也能用、不繞回 Shell）。
import type { ScopeNode } from './myDevices';

type T = (k: string, o?: Record<string, unknown>) => string;

export function scopeNodeName(t: T, n: Pick<ScopeNode, 'kind' | 'label' | 'source' | 'orgKind'>): string {
  if (n.kind === 'source') return t(`scope.src_${n.source}`);
  if (n.kind === 'external') return t('scope.external');
  if (n.kind === 'delegation') return t('ot.dlg_label', { from: n.label });
  if (n.kind === 'sharer') return n.label || t('scope.sharer_unknown');
  if (n.kind === 'org' && n.orgKind === 'personal' && !n.label) return t('scope.personal_org');
  return n.label;
}
